import React from 'react'
import {
    Box, Input, Button, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Select, Text, Flex,
    HStack, VStack, useDisclosure, Modal, ModalOverlay, ModalContent,
    ModalBody, useToast, FormControl, FormLabel, FormErrorMessage,
} from "@chakra-ui/react";
import LeftSidebar from "../LeftSideBarLayout/LeftSideBar";
import HeaderBar from "../Header/HeaderBar";
import { GoHomeFill } from "react-icons/go";
import Footer from "../footer";

const EditSubscription = () => {
  return (
    <Box backgroundColor='#F0F4F9' height={"100%"}>
            <HStack pl='20px' pr={"6px"} w={"100%"} spacing={0} alignItems='flex-start'>
                <LeftSidebar />
                <Box as='main' minW={0} flex={1} ml={"6px"}>
                    <HeaderBar />
                    <Box p={4} bg="white" mt='0rem' padding='12px 20px'>
                        <Breadcrumb color="#8B8D97" padding="10px 0px 0.5rem 0px">
                            <BreadcrumbItem>
                                <BreadcrumbLink href='/overview'><GoHomeFill color="#5570F1" /></BreadcrumbLink>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                <BreadcrumbLink href='/Subscriptions-status' color='#8B8D97' fontSize='13px'>Subscription List </BreadcrumbLink>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                <BreadcrumbLink href='/Subscriptions-status/edit-Subscription' color='#8B8D97' fontSize='13px'>Edit Subscription</BreadcrumbLink>
                            </BreadcrumbItem>
                        </Breadcrumb>
                     <div>EditSubscription</div>
                    </Box>
                    <Footer />
                </Box>
            </HStack>
                                    

        </Box>
  )
}

export default EditSubscription;